import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/context/I18nContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import MarqueeStrip from "@/components/Marquee";
import Products from "@/components/Products";
import Process from "@/components/Process";
import TextileFacility from "@/components/TextileFacility";
import Strengths from "@/components/Strengths";
import Certifications from "@/components/Certifications";
import GlobalReach from "@/components/GlobalReach";
import Inquiry from "@/components/Inquiry";
import Footer from "@/components/Footer";
import Inbox from "@/pages/Inbox";
import ProductDetail from "@/pages/ProductDetail";

function Home() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rid;
    const raf = (time) => { lenis.raf(time); rid = requestAnimationFrame(raf); };
    rid = requestAnimationFrame(raf);
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) { e.preventDefault(); lenis.scrollTo(el, { offset: id === "#top" ? 0 : -70 }); }
      }
    };
    document.addEventListener("click", onClick);
    return () => { cancelAnimationFrame(rid); document.removeEventListener("click", onClick); lenis.destroy(); };
  }, []);

  return (
    <div className="App noise-overlay bg-brand-bg text-brand-fg font-sans min-h-screen">
      <Header />
      <main>
        <Hero />
        <MarqueeStrip />
        <Products />
        <Process />
        <TextileFacility />
        <Strengths />
        <Certifications />
        <GlobalReach />
        <Inquiry />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/inbox" element={<Inbox />} />
          <Route path="/product/:id" element={<ProductDetail />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" toastOptions={{ style: { background: "#ffffff", color: "#1C1813", border: "1px solid #EAE3D5" } }} />
    </I18nProvider>
  );
}

export default App;
